import PropTypes from "prop-types";

import { PurchasePlanModalContainer } from "./PurchasePlanModal.styles";
import { PurchasePlanCard } from "shared/PurchasePlanCard";

const PurchasePlanModal = ({
  onHide,
  show = false,
  isCancelPlan,
  isChangePlan,
}) => {
  return (
    <PurchasePlanModalContainer onHide={onHide} size="xl" show={show}>
      <PurchasePlanCard
        handleExplore={onHide}
        isCancelPlan={isCancelPlan}
        isChangePlan={isChangePlan}
      />
    </PurchasePlanModalContainer>
  );
};

export { PurchasePlanModal };

PurchasePlanModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  isCancelPlan: PropTypes.bool,
  isChangePlan: PropTypes.bool,
};
